import {useState,useEffect} from "react";
import realtimeDB from "../Utils/api";

const useImagenesCarta=(firebaseId)=>
{
    const [Imagenes, setImagenes] = useState([]);

    const Path= `/Cartas/${firebaseId}`
    
    useEffect(() => 
    {
        if(Path !== undefined)
        {
            realtimeDB.ref(Path).on("value",snapshot =>
            {
                var imagenes=[];
                snapshot.forEach(imagen =>
                {
                    imagenes.push({id:imagen.key,data:imagen.val()})
                });
                imagenes=imagenes.sort((a,b) => (a.data.index > b.data.index) ? 1 : ((b.data.index > a.data.index) ? -1 : 0))
                setImagenes(imagenes);
            })
        }       
    }, [Path])
    
    return Imagenes
}

export default useImagenesCarta;